import React, { useState } from 'react';
import ReactPlayer from 'react-player';

type IVideoAppProp = {
  video_url: string
}

const VideoApp: React.FC<IVideoAppProp> = ({video_url}) => <ReactPlayer url={video_url} controls={true} width="420px" height="240px" playing={false}/>

export default VideoApp;